// SISTEMA DE GRID
// La cancha es un CSS Grid de 4 filas × 11 columnas
// Columnas 1 y 11 son márgenes vacíos
// Jugadores van de col 2 a 10
// Líneas de 5: cols 2,4,6,8,10
// Líneas de 4: cols 2,4,7,9  (o similar)
// fila 1=DEL, 2=VOL, 3=DEF, 4=ARQ

export const COORDENADAS_FORMACIONES = {

  '4-3-3': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 5,  pos: 'DEF' }, { fila: 3, col: 7,  pos: 'DEF' }, { fila: 3, col: 9, pos: 'DEF' },
    { fila: 2, col: 4,  pos: 'VOL' }, { fila: 2, col: 6,  pos: 'VOL' }, { fila: 2, col: 8,  pos: 'VOL' },
    { fila: 1, col: 4,  pos: 'DEL' }, { fila: 1, col: 6,  pos: 'DEL' }, { fila: 1, col: 8, pos: 'DEL' },
  ],

  '4-4-2': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 5,  pos: 'DEF' }, { fila: 3, col: 7,  pos: 'DEF' }, { fila: 3, col: 9, pos: 'DEF' },
    { fila: 2, col: 3,  pos: 'VOL' }, { fila: 2, col: 5,  pos: 'VOL' }, { fila: 2, col: 7,  pos: 'VOL' }, { fila: 2, col: 9, pos: 'VOL' },
    { fila: 1, col: 4,  pos: 'DEL' }, { fila: 1, col: 8,  pos: 'DEL' },
  ],

  '3-5-2': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 6,  pos: 'DEF' }, { fila: 3, col: 9,  pos: 'DEF' },
    { fila: 2, col: 2,  pos: 'VOL' }, { fila: 2, col: 4,  pos: 'VOL' }, { fila: 2, col: 6,  pos: 'VOL' }, { fila: 2, col: 8,  pos: 'VOL' }, { fila: 2, col: 10, pos: 'VOL' },
    { fila: 1, col: 4,  pos: 'DEL' }, { fila: 1, col: 8,  pos: 'DEL' },
  ],

  '5-3-2': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 2,  pos: 'DEF' }, { fila: 3, col: 4,  pos: 'DEF' }, { fila: 3, col: 6,  pos: 'DEF' }, { fila: 3, col: 8,  pos: 'DEF' }, { fila: 3, col: 10, pos: 'DEF' },
    { fila: 2, col: 3,  pos: 'VOL' }, { fila: 2, col: 6,  pos: 'VOL' }, { fila: 2, col: 9,  pos: 'VOL' },
    { fila: 1, col: 4,  pos: 'DEL' }, { fila: 1, col: 8,  pos: 'DEL' },
  ],

  '3-4-3': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 6,  pos: 'DEF' }, { fila: 3, col: 9,  pos: 'DEF' },
    { fila: 2, col: 2,  pos: 'VOL' }, { fila: 2, col: 5,  pos: 'VOL' }, { fila: 2, col: 7,  pos: 'VOL' }, { fila: 2, col: 10, pos: 'VOL' },
    { fila: 1, col: 2,  pos: 'DEL' }, { fila: 1, col: 6,  pos: 'DEL' }, { fila: 1, col: 10, pos: 'DEL' },
  ],

  '4-5-1': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 5,  pos: 'DEF' }, { fila: 3, col: 7,  pos: 'DEF' }, { fila: 3, col: 9, pos: 'DEF' },
    { fila: 2, col: 2,  pos: 'VOL' }, { fila: 2, col: 4,  pos: 'VOL' }, { fila: 2, col: 6,  pos: 'VOL' }, { fila: 2, col: 8,  pos: 'VOL' }, { fila: 2, col: 10, pos: 'VOL' },
    { fila: 1, col: 6,  pos: 'DEL' },
  ],

  '5-2-3': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 2,  pos: 'DEF' }, { fila: 3, col: 4,  pos: 'DEF' }, { fila: 3, col: 6,  pos: 'DEF' }, { fila: 3, col: 8,  pos: 'DEF' }, { fila: 3, col: 10, pos: 'DEF' },
    { fila: 2, col: 4,  pos: 'VOL' }, { fila: 2, col: 8,  pos: 'VOL' },
    { fila: 1, col: 2,  pos: 'DEL' }, { fila: 1, col: 6,  pos: 'DEL' }, { fila: 1, col: 10, pos: 'DEL' },
  ],

  '4-2-4': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 5,  pos: 'DEF' }, { fila: 3, col: 7,  pos: 'DEF' }, { fila: 3, col: 9, pos: 'DEF' },
    { fila: 2, col: 5,  pos: 'VOL' }, { fila: 2, col: 7,  pos: 'VOL' },
    { fila: 1, col: 3,  pos: 'DEL' }, { fila: 1, col: 5,  pos: 'DEL' }, { fila: 1, col: 7,  pos: 'DEL' }, { fila: 1, col: 9, pos: 'DEL' },
  ],

  '3-3-4': [
    { fila: 4, col: 6,  pos: 'ARQ' },
    { fila: 3, col: 3,  pos: 'DEF' }, { fila: 3, col: 6,  pos: 'DEF' }, { fila: 3, col: 9,  pos: 'DEF' },
    { fila: 2, col: 3,  pos: 'VOL' }, { fila: 2, col: 6,  pos: 'VOL' }, { fila: 2, col: 9,  pos: 'VOL' },
    { fila: 1, col: 3,  pos: 'DEL' }, { fila: 1, col: 5,  pos: 'DEL' }, { fila: 1, col: 7,  pos: 'DEL' }, { fila: 1, col: 9, pos: 'DEL' },
  ],
};